import { Injectable } from '@angular/core';
import { IGAFormActionEventRequest, IGAFormMetadata } from './forms.service';
import _ from 'underscore';
import { IObject } from '@type_definitions/datatypes';
import { HttpDataService } from '@app/shared/http/http-data.service';
import { GaDeferredService, IGADeferred } from '@app/shared/services/ga-deferred.service';

const ERROR:string = 'ERROR';

@Injectable()
export class FormsDataService {
  private formCookies:IObject = {};

  constructor(
    private httpDataService:HttpDataService,
    private deferredService:GaDeferredService
  ) {
    /**/
  }

  public postActionEvent(formId:string, request:IGAFormActionEventRequest):Promise<IGAFormMetadata | string> {
    const cancelIdSuffix:string = request.actions?.[ 0 ]?.type || `${request.events[ 0 ].type}_${request.events[ 0 ].source}`;
    const cancelId:string = `${formId}_${cancelIdSuffix}`;
    const deferred:IGADeferred<IGAFormMetadata | string> = this.deferredService.defer();

    // check if form cookies defined, then append it to request context object property
    if (this.formCookies[formId]) {
      request.context = _.extend(request.context || {}, { cookies: this.formCookies[formId] });
    }

    this.httpDataService.doPOST(
      `/ga3/forms/${formId}`,
      undefined,
      request,
      undefined,
      undefined,
      cancelId,
      true
    ).then((response:IGAFormMetadata) => {
      if (response.status === ERROR) {
        deferred.reject(response.text);
      } else {
        // store form cookies and send it back to server whenever request occurred
        if (response.cookies) {
          this.formCookies[formId] = response.cookies;
        }

        deferred.resolve(response);
      }
    }).catch((response:any) => {
      console.debug(response);
      deferred.reject(response?.status !== 0? `${response.text || response.message || ERROR}` : undefined);
    });

    return deferred.promise;
  }

  public cancelAllRequests(formId:string):void {
    // cancel all http requests containing coming from ga3 forms
    this.httpDataService.cancelAllRequests(formId);
  }

  public clearFormCookies(formId: string): void {
    delete this.formCookies[formId];
  }
}